import { render, staticRenderFns } from "./License.vue?vue&type=template&id=2bc1c72b&"
import script from "./License.vue?vue&type=script&lang=ts&"
export * from "./License.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports